export default __webpack_public_path__ + "static/numerical-analysis-0b03b052f96d15b7de7e7692c29cb274.svg";